import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchStatsSettings, type FetchStatsSettingsParams } from '../../api/fetchers/settings/fetcher';

export const fetchStatsSettingsAction = createAsyncThunk(
  'statsSettings/fetchStatsSettings',
  (params: FetchStatsSettingsParams) => fetchStatsSettings(params)
);
